<template>
  <div>
    <window title="Card Widgets">
      <!-- Widget Card counter -->
      <div class="columns is-mobile is-multiline">
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-counter backgroundColor="#c62828" icon="fas fa-3x fa-envelope"
          title="New messages" subtitle="23"></widget-counter>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-counter backgroundColor="#6A1B9A" icon="fas fa-3x fa-cloud"
          title="Forecast" subtitle="23'C"></widget-counter>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-counter backgroundColor="#283593" icon="fas fa-3x fa-dollar-sign"
          title="Today" subtitle="250.000"></widget-counter>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-counter backgroundColor="#0277BD" icon="fas fa-3x fa-euro-sign"
          title="Today" subtitle="250.000"></widget-counter>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-counter backgroundColor="#00695C" icon="fas fa-3x fa-lira-sign"
          title="Today" subtitle="147.000"></widget-counter>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-counter backgroundColor="#558B2F" icon="fas fa-3x fa-yen-sign"
          title="Today" subtitle="2540.000"></widget-counter>
        </div>
      </div>
      <!-- Widget simple -->
      <div class="columns is-mobile is-multiline">
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-simple backgroundColor="#F9A825" icon="fas fa-3x fa-dollar-sign" value="250">
          </widget-simple>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-simple backgroundColor="#EF6C00" icon="fas fa-3x fa-bell" value="23">
          </widget-simple>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-simple backgroundColor="#4E342E" icon="fas fa-3x fa-users" value="720">
          </widget-simple>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-simple backgroundColor="#37474F" icon="fas fa-3x fa-thumbs-up" value="77">
          </widget-simple>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-simple backgroundColor="#AD1457" icon="fas fa-3x fa-address-book" value="52">
          </widget-simple>
        </div>
        <div class="column is-half-desktop is-full-touch is-4-widescreen">
          <widget-simple backgroundColor="#4527A0" icon="fas fa-3x fa-address-card" value="7">
          </widget-simple>
        </div>
      </div>
    </window>

    <div class="columns">
      <div class="column is-one-quarter">
        <window title="Profile" height="100%">
          <!-- Widget Card Big -->
          <widget-profile></widget-profile>
        </window>
      </div>
      <div class="column is-one-quarter">
        <window title="TODO" height="100%">
          <!-- Widget "ToDo List" -->
          <widget-todo :items="todos"></widget-todo>
        </window>
      </div>
      <div class="column">
        <window title="Progress Bars" height="100%">
          <progress class="progress is-primary" value="15" max="100">30%</progress>
          <progress class="progress is-link" value="30" max="100">30%</progress>
          <progress class="progress is-info" value="45" max="100">45%</progress>
          <progress class="progress is-success" value="60" max="100">60%</progress>
          <progress class="progress is-warning" value="75" max="100">75%</progress>
          <progress class="progress is-warning" value="75" max="100">75%</progress>
          <progress class="progress is-danger" value="90" max="100">90%</progress>
          <progress class="progress is-danger" value="90" max="100">90%</progress>
        </window>
      </div>
    </div>
  </div>
</template>

<script>
import widgetCounter from '@/components/widgets/Counter.vue';
import widgetSimple from '@/components/widgets/Simple.vue';
import widgetProfile from '@/components/widgets/Profile.vue';
import widgetTodo from '@/components/widgets/Todo.vue';

export default {
  components: {
    widgetCounter,
    widgetSimple,
    widgetProfile,
    widgetTodo,
  },
  data() {
    return {
      todos: [{
        title: 'Todo 1',
        checked: false,
      }, {
        title: 'Todo 2',
        checked: false,
      }, {
        title: 'Todo 3',
        checked: false,
      }, {
        title: 'Todo 4',
        checked: false,
      }, {
        title: 'Todo 5',
        checked: false,
      }],
    };
  },
};
</script>
